<app-grid-container class="checkout">
  <app-grid-row class="white-container">
    <app-grid-column>
      <app-grid-row>
        <app-grid-column [md]="6" [xs]="4">
          <div class="checkout__go-back">
            <i class="fa-solid fa-arrow-left"></i>
            <button
              (click)="navigateBack()"
              class="checkout__go-back-btn"
              type="button"
            >
              {{ "CHECKOUT_DIRECT_DEBIT_FORM_LINK_GO_BACK" | translate }}
            </button>
          </div>
        </app-grid-column>
        <app-grid-column [md]="6" [xs]="8">
          <app-progression-steps />
        </app-grid-column>
      </app-grid-row>

      <app-grid-row>
        <app-grid-column class="checkout__heading-container">
          <h1 class="checkout__heading">Securely enter your payment details</h1>
          <p class="checkout__subheading">
            Domestic & General Insurance PLC will arrange your payment plan and
            keep your data secure and encrypted.
          </p>
        </app-grid-column>
      </app-grid-row>

      <app-grid-row>
        <app-grid-column>
          <app-direct-debit-form (submitted)="onFormSubmit($event)" />
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>

  <app-grid-row>
    <app-grid-column>
      <app-basket-sticky-wrapper>
        <app-basket />
      </app-basket-sticky-wrapper>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
